import React, {useState} from 'react';
import {AutoCompleteWidgetChoose} from '../autocomplete/select/auto-complete-widget-choose';
import {AutoCompleteVendasSelect} from './autocomplete-vendas-select';
import { VendaSelecionada } from './venda-selecionada';

const AutoCompleteVendasWidget = ({getApi, onSelect, onChange}) => {
    
    const [selectedItem, setSelectedItem] = useState("");
    

    const onSelectHandle = (value) => {
        setSelectedItem(value);
        onSelect && onSelect(value);
        onChange && onChange(value);
    }

    //autoComplete.props.onSelect = onSelectHandle;

    return <AutoCompleteWidgetChoose
        autoComplete={
            <AutoCompleteVendasSelect
                getApi={getApi}
                onSelect={onSelectHandle}
            ></AutoCompleteVendasSelect> 
        }
        onSelect={onSelectHandle}
        selectedItem={selectedItem}
        selectedTemplate={
            <VendaSelecionada venda={selectedItem}></VendaSelecionada>
        }
    ></AutoCompleteWidgetChoose>
}


export { AutoCompleteVendasWidget }